<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentPlan /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentPlan from '@/components/team/dashboard/modules/plan/ContentPlan.vue'

export default 
{
  name: 'Plan',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentPlan
  }
}
</script>
<style>

</style>